import { z } from 'zod';
import { AppSdkError } from '../runtime/tier0/sdk-error.mjs';

const id = z.string().min(1).max(200);
const ids = z
  .array(id)
  .min(1)
  .max(50)
  .refine((items) => new Set(items).size === items.length);
export const collectionMentionsSchema = z
  .array(
    z
      .object({
        bindingRef: id,
        collectionId: id,
        rowId: id,
        fieldIds: ids,
        recipientIds: ids,
      })
      .strict(),
  )
  .min(1)
  .max(50)
  .refine(
    (items) =>
      new Set(items.map((item) => JSON.stringify([item.collectionId, item.rowId]))).size ===
      items.length,
  );

/** Explicit C8 intent only. Parsing never authenticates a recipient or event. */
export function mentionsMatchChanges(mentions, changes) {
  return mentions.every((mention) => {
    const row = changes.find(
      (change) => change.collectionId === mention.collectionId && change.rowId === mention.rowId,
    );
    return (
      row && row.kind !== 'delete' && mention.fieldIds.every((id) => Object.hasOwn(row.values, id))
    );
  });
}

export function parseCollectionMentions(value, changes) {
  const parsed = collectionMentionsSchema.safeParse(value);
  if (!parsed.success || !mentionsMatchChanges(parsed.data, changes))
    throw new AppSdkError('INVALID_INPUT');
  return parsed.data;
}
